import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import { useUserStore } from '../store/userStore';

export const useUpdateUser = () => {
  const { state, actions } = useUserStore();
  const mutation = useMutation({
    mutationFn: (data: {
      first_name: string;
      second_name: string;
      referral?: string;
    }) => API.updateUser(data),
    onSuccess: (data) =>
      actions.setUser({
        ...state,
        fio: data.data.payload.fio,
        first_name: data.data.payload.first_name,
        second_name: data.data.payload.second_name,
      }),
  });

  return {
    update: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
};
